import React, {useState,useEffect,useMemo} from 'react';
import useStyles from './Styles';
import Hidden from '@mui/material/Hidden';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Divider from '@mui/material/Divider';
import InquiryConfirm from './InquiryConfirm';
import {Owner,Inquiry} from './Inc';
import ColInput from './ColInput';
import BottomButtons from './BottomButtons';
import Ajax from './Ajax';
import Toast from './Toast';
//import Success from './Success';
import Title from './Title';
import Loading from './Loading';

interface Props {
	owner:Owner,
}

const InquiryInput = (props:Props)=> {
	const classes = useStyles();

	const def:Inquiry = {
		name: props.owner.customer.name,
		kana: props.owner.customer.kana,
		mail: props.owner.customer.mail,
		text: "",
	}
	const [values, setValues] = useState(def);
	const [toast,setToast] = useState("");
	const [flags,setFlags] = useState({
		errors: [] as string[],
		isThanks: false,
		isLoading: false,
		isConfirm: false,
		isSuccess: false,
	});

	const handleModalClose = ()=>{
		setFlags({...flags,"isConfirm":false});
	};

	// const handleChange = (name: keyof Inquiry) => (event: React.ChangeEvent<HTMLInputElement>) => {
	// 	setValues({ ...values, [name]: event.target.value });
	// };

	const change = (name:keyof Inquiry,value:string)=>{
		setValues(prev=>({...prev,[name]:value}));
	}
	const addError = (name:keyof Inquiry,isError:boolean) =>{
		setFlags(prev => {
			const errors = [...prev.errors];
			if( isError ){
				if( !errors.includes(name) ){
					errors.push( name );
				}
			} else {
				if( errors.includes(name) ){
					const index = errors.findIndex((v) => v===name);
					errors.splice(index,1);
				}
			}
			return { ...prev, errors: errors }
		});
	}

	const closeToast = ()=>{
		setToast("");
	}
	const closeSuccess = ()=>{
		setFlags({...flags,"isSuccess":false});
		//isThanks = false;
	}
	const validate = ()=>{
		let error = false;
		if( values.name==="" || values.kana==="" || values.mail==="" || values.text==="" ){
			error = true;
		}

		if( error ){
			setToast("まだ入力されていない欄があります。");
		} else {
			setFlags({...flags,"isConfirm":true});
		}
	}
	const send = ()=>{
		setFlags({...flags,"isLoading":true});
		//setFlags({"isLoading":false,"isConfirm":false,"isSuccess":true});
		//setValues(def);
		
		Ajax.send("inquiry/send",values,(res:any)=>{
			if( res.ok ){
				//isThanks = true;
				setFlags({errors:[],"isLoading":false,"isConfirm":false,"isSuccess":true,"isThanks":true});
				setValues(def);
				window.scrollTo(0, 0);
			} else {
				setFlags({errors:[],"isLoading":false,"isConfirm":false,"isSuccess":false,"isThanks":false});
				setToast("送信に失敗しました。");
			}
		});
		
	}
	const guide1 = useMemo( ()=>{
		return (
			<div style={{marginBottom:'2em'}}>
				<p className={classes.p}>架空ストアSideBに関するお問い合わせはこちらからどうぞ。</p>
				<p className={classes.p}>お問い合わせへの返答は、なるべく早い対応を心がけてはおりますが、業務の都合上数日のお時間をいただく場合もございます。どうぞ気長にお待ち下さい。</p>
			</div>
		)
	},[]);
	const guide2 = useMemo( ()=>{
		return (
			<>
				<p className={classes.hintFirst}>
					※ご利用のメールのセキュリティ設定によっては、架空ストアからのメールが「迷惑メール」扱いになってしまうことがあります。メールが届かない場合は、「迷惑メール」フォルダの中を念のためご確認下さい。<br/>
				</p>
				<Divider/>
				<p style={{textAlign:"center"}}>
					架空ストアのメールアドレス<br/>
					<b style={{fontSize:"120%"}}>store@retro-biz.com</b>
				</p>
				<Divider/>
			</>
		)
	},[]);

	useEffect( ()=>{
		const defErrors = ["name","kana","mail","text"];
		const errors = defErrors.filter((key) => {
			return !values[key as keyof Inquiry] || values[key as keyof Inquiry].trim() === "";
		});
		setFlags({errors:errors,"isLoading":false,"isConfirm":false,"isSuccess":false,"isThanks":false});
		window.scrollTo(0,0);
	},[]);

	return (
		<div className={classes.root}>
			<Grid container spacing={2}>
				{flags.isThanks ? (
				<Grid item xs={12} md={12}>
					<Paper className={classes.paper}>
						<div style={{marginBottom:"3em"}}>
							<Title text="お問い合わせ" size={1} icon="store"/>
							<div className={classes.section}>
								<p>お問い合わせをうけたまわりました。</p>
								<p><b>store@retro-biz.com</b>から確認メールを送信しましたのでご確認下さい。</p>
								<p>数時間経過しても確認メールが届かない場合は入力されたメールアドレスが正しくない可能性がありますので、お手数ですが再度お問い合わせをお願いいたします。</p>
							</div>
							<div className={classes.section}>
								<p>通常１営業日以内に当店担当者からご連絡を差し上げます。</p>
								<p>それ以上たっても返信がない場合は、架空ストアからのメールが迷惑メール扱いになってしまっている可能性がありますので、お手数ですが迷惑メールフォルダなどをご確認いただくか、別のメールアドレスで再度ご連絡をお願いいたします。</p>
							</div>
						</div>
					</Paper>
				</Grid>
				):(
				<React.Fragment>
				<Grid item xs={12} md={8}>
					<Paper className={classes.paper}>
						<Title text="お問い合わせ" size={1} icon="store"/>
						<Hidden mdUp implementation="js">
							<div className="firstTalk">
								{guide1}
							</div>
						</Hidden>

						<div style={{marginBottom:"2em"}}>
							<Grid container spacing={2}>
								<Grid item xs={12} sm={6}>
									<ColInput name="お名前" value={values.name} addError={addError} change={change} maxLength={50} id="name" helper="50文字以内" placeholder='架空作家' type="text" required/>
								</Grid>
								<Grid item xs={12} sm={6}>
									<ColInput name="お名前（カナ）" value={values.kana} addError={addError} change={change} maxLength={50} id="kana" helper="50文字以内" placeholder='カクウサッカ' type="text" required/>
								</Grid>
								<Grid item xs={12} sm={12}>
									<ColInput name="メールアドレス" value={values.mail} addError={addError} change={change} maxLength={100} id="mail" helper="100文字以内" type="text" required/>
								</Grid>
								<Grid item xs={12} sm={12}>
									<ColInput name="お問い合わせ内容" value={values.text} addError={addError} change={change} maxLength={2000}
										id="text" helper="2000文字以内"
										type="textarea" rows={4}
										required/>
								</Grid>
							</Grid>
						</div>
						<BottomButtons button1='内容の確認' onClick1={validate} disabled1={flags.errors.length>0}/>
						<Hidden mdUp implementation="js">
							<div style={{marginTop:"4em"}}>
								{guide2}
							</div>
						</Hidden>

					</Paper>
				</Grid>
				<Hidden mdDown implementation="js">
				<Grid item xs={12} md={4}>
					<Paper className={classes.paper}>
						<Title text="不明な点がございましたら" size={2}/>
						{guide1}
						{guide2}
					</Paper>
				</Grid>
				</Hidden>
				</React.Fragment>
				)}
			</Grid>
			<InquiryConfirm send={send} close={handleModalClose} inquiry={values} isOpen={flags.isConfirm}/>
			<Toast close={closeToast} mes={toast}/>
			<Loading isLoading={flags.isLoading}/>
		</div>
	);
}

export default InquiryInput;
